
import events from 'events';
import PullLoading from './pulloading';
import util from '../../../lib/util';

const isPC = util.isPC();

require('./style.scss');


export default class HeadPanel extends events {
  constructor(cfg) {
    super();
    this.$container = cfg.container;
    this.$frame = cfg.parentCont;
    this.log = cfg.log;
    this.useNative = null;
    this.items = [];
    this.pullLoading = new PullLoading();
    this.init();
  }

  init() {
    const $container = this.$container;
    this.$back = $container.find('.head-back');
    this.$title = $container.find('.caption');
    this.$close = $container.find('.right-nav');
    this.$menu = $container.find('.more-menu');
    this.$list = $container.find('.J_MoreMenu');
    this.$avatar = $container.find('.im-avatar-wrap');
    this.$rightnav = $container.find('.right-nav');
    this.$notify = $container.find('.J_Notify');
    this.$notifyList = $container.find('.J_NotifyList');
    this.$notifyTip = $container.find('.J_NotifyTip');
    this.$notifyNew = $container.find('.J_NotifyNew');
    this.$remind = $container.find('.J_Remind');
    this.$service = $container.find('.J_Service');
    const richAvatar = `<div class="im-avatar">
                          <div class="avatar-wrap J_Robot">
                            <div class="avatar-head"></div>
                            <div class="avatar-body"></div>
                            <div class="avatar-tie"></div>
                          </div>
                          <div class="J_OCS">
                            <div class="avatar-head"></div>
                            <img src="" />
                          </div>
                        </div>`;
    this.$avatar.html(richAvatar);
    this.pullLoading.init(this.$avatar.find('.im-avatar'));
    if (isPC) {
      this.$back.hide();
      this.$title.css({ textAlign: 'left' });
    } else {
      this.$close.hide();
    }
    this.bindEvent();
    if (this.items.length) {
      this.addMenus(this.items);
    }
  }

  /**
   * 获取url上的参数
   * @returns {*}
   * @private
   */
  getQueryString() {
  }

  /**
   * hack
   * 隐藏顶部导航，隐藏不成功则隐藏返回和更多按钮
   * 支付宝由于隐藏导航之后，跳转到下个页面导航不会恢复，所以暂时不隐藏
   * 对于天猫的隐藏导航，需要在顶部加20px
   * @return {[type]} [description]
   */
  hideNavbar() {

  }

  hack() {
    // 在不能隐藏顶部bar的情况下，隐藏返回和更多
    const $container = this.$container;
    $container.find('.J_Back').hide();
    $container.find('.J_MoreMenu').hide();
  }

  bindEvent() {
    this.$back.on('tap', () => {
      history.back();
    });

    this.$close.on('click', () => {
      $('.m-alicare').hide();
    });
  }
  /**
   * 设置自定义头像
   * @param {any} config[触角，身体face，领结tie]
   * @memberOf HeadPanel
   */
  setCustomedAvatar(config) {
    if (config.tie) {
      this.$container.find('.avatar-tie').css({
        'background-image': `url(${config.tie})`,
      });
    }
    if (config.face) {
      this.$container.find('.avatar-body').css({
        'background-image': `url(${config.face})`,
      });
    }
  }

  addNotifyList() {

  }


  showNotifyList() {

  }

  hideNotifyList() {
  }

  showNotifyTip() {
    this.$notifyTip.show();
    setTimeout(() => {
      this.$notifyTip.fadeOut();
    }, 2000);
  }

  showNotifyNew() {
    this.$notifyNew.show();
  }

  hideNotifyNew() {
    this.$notifyNew.hide();
  }

  addMenus() {

  }

  showMenu() {

  }

  hideMenu() {
  }

  showRemind() {

  }

  showService() {

  }

  setTitle() {

  }

  switchRole() {

  }
  /**
   * 转人工头像
   * @param {any} img
   * @memberOf HeadPanel
   */
  setOcsAvatar() {

  }

  hide() {
    this.$container.hide();
  }

}



// WEBPACK FOOTER //
// ./src/component/view/head/index.js